// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__iy581","info":"Panel_info__v-yRu","btns":"Panel_btns__3uZbq","button":"Panel_button__1_itz"};